/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="employeeTemplatePromotions.module.ts" />
/// <reference path="../../components/controls/controls.module.ts" />

module Meevo.Plugins.EmployeeTemplatePromotions {
  class EmployeeTemplatePromotionsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {
    employeeDetail: Model.DataDetail;

    static $inject = [
      "meevo.AppSettings",
      "meevo.components.common.DataService",
      "meevo.components.modal.ModalService",
      "meevo.components.common.IdentityService",
      "meevo.components.logging.LoggingService",
      "meevo.components.common.SecurityService",
      "meevo.components.tracking.TrackingService",
      "$rootScope",
      "$scope",
      "$state",
      "meevo.ContextParams",
      'meevo.components.short-cuts.ShortCutsService',

      "meevo.components.busy.BusyService",
      "$translate"];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
          protected dataService: Meevo.Components.BaseClasses.IDataService,
          protected modalService: Meevo.Components.Modal.IModalService,
          protected identityService: Meevo.Components.Common.IIdentityService,
          protected loggingService: Meevo.Components.Logging.ILoggingService,
          protected securityService: Meevo.Components.Common.ISecurityService,
          protected trackingService: Meevo.Components.Tracking.ITrackingService,
          protected $rootScope: angular.IRootScopeService,
          protected $scope: angular.IScope,
          protected $state: any,
          protected contextParams: Meevo.IContextParams,
          protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

          protected busyService: Meevo.Components.Busy.IBusyService,
          protected $translate: angular.translate.ITranslateService) {

          super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        /**
        * Creates the context for editing/adding an item.
        * @return {}
        */
        createContext(): void {
          let vm = this;
          vm.busyService.start();
          vm.securityService.checkSection(vm.meevoSecurityKeys.DATA_EMPLOYEETEMPLATEPROMOTION).then(() => {
            vm.busyService.stop();
            vm.context = new EmployeeTemplatePromotionsContext(vm.appSettings, vm.dataService, vm.modalService, vm.identityService, vm.loggingService, this.securityService, vm.trackingService, vm.$translate, vm.employeeDetail);
            vm.context.activate(vm.selectedItemId);
            vm.context.deactivate = () => {
              vm.visualState = Model.MaintenanceFormVisualState.Search;
            }
          }
        )};

        async applyParams(params) {
            await super.applyParams(params);
            if (Model.Guard.isSomething(params) && Model.Guard.isSomething(params.employeeId)) {
                // Get context
                let context = (<EmployeeTemplatePromotionsContext>this.context);
                // Update context and rebuild sections
                if (Model.Guard.isSomething(context) && this.visualState === Model.MaintenanceFormVisualState.Detail) {
                    context.employeeDetail = { id: params.employeeId };
                    context.reinitializeSetcions();
                    context.activate(this.selectedItemId);
                }
                else if (params.actionState === Model.MaintenanceFormState.Adding) {
                    this.employeeDetail = { id: params.employeeId };
                }
            }
        }

        notificationBeforeAddState(): angular.IPromise<any> {
          var vm = this;
          vm.employeeDetail = null;
          let options: Meevo.Components.Modal.IModalOptions = {
            templateUrl: "app/plugins/employeeTemplatePromotions/sectionViews/initializePromotionEmployee.html",
            clickOutsideToClose: false,
            locals: {
              context: vm
            },
            controller: "meevo.plugins.employeeTemplatePromotions.PromotionEmployeeController",
            controllerAs: "vm"
          }

          return this.modalService.showCustom(options);
        }

        get instructionsLabel(): any {
          var message = this.$translate.instant("LABEL_SCHEDULED_PROMOTIONS_INSTRUCTIONS");
          return message;
        }
    }


  angular.module("meevo.plugins.employeeTemplatePromotions")
    .controller("meevo.plugins.employeeTemplatePromotions.EmployeeTemplatePromotionsController", EmployeeTemplatePromotionsController);
}


module Meevo.Plugins.EmployeeTemplatePromotions {
  class PromotionEmployeeController extends Meevo.Components.Controls.ModalContextController {

    apply = (arr: any) => {
      if (Model.Guard.isSomething(this.context.employeeDetail))
        this.$mdDialog.hide();
    }
  }

  angular.module("meevo.plugins.employeeTemplatePromotions")
    .controller("meevo.plugins.employeeTemplatePromotions.PromotionEmployeeController", PromotionEmployeeController);
}